export const defaultTag = 'span';
